import request from '@/libs/request';
import config from '@/config';
const baseUrl = config.api_base;

// 日志管理

/**
 * 用户登录操作事件日志
 * @param {*} params
 * @returns
 */

export const LoginLog = params => {
  return request('get', `${baseUrl}/api/auth/sys/log/login`, params);
};

/**
 * 用户客户操作事件日志
 * @param {*} params
 * @returns
 */

export const CustomerActionLog = params => {
  return request('get', `${baseUrl}/api/auth/sys/log/customer`, params);
};

/**
 * 设备操作事件日志
 * @param {*} params
 * @returns
 */

export const DeviceActionLog = params => {
  return request('get', `${baseUrl}/api/auth/sys/log/dev/basic`, params);
};

/**
 * 执行设备命令操作事件日志
 * @param {*} params
 * @returns
 */

export const DeviceOptLog = params => {
  return request('get', `${baseUrl}/api/auth/sys/log/dev/opt`, params);
};

/**
 * 设备问题发起事件日志
 * @param {*} params
 * @returns
 */

export const DeviceIssueLog = params => {
  return request('get', `${baseUrl}/api/auth/sys/log/issue`, params);
};

/**
 * 设备模型操作日志
 * @param {*} params
 * @returns
 */

export const DeviceModelLog = params => {
  return request('get', `${baseUrl}/api/auth/sys/log/dev/model`, params);
};

/**
 * 站点操作事件日志
 * @param {*} params
 * @returns
 */

export const SiteActionLog = params => {
  return request('get', `${baseUrl}/api/auth/sys/log/station`, params);
};

/**
 * 用户操作日志
 * @param {*} params
 * @returns
 */

export const UserActionLog = params => {
  return request('get', `${baseUrl}/api/auth/sys/log/user`, params);
};

/**
 * MQTT消息操作事件日志
 * @param {*} params
 * @returns
 */

export const MqttActionLog = params => {
  return request('get', `${baseUrl}/api/auth/sys/log/mqtt`, params);
};

/**
 * 设备故障日志记录设备产生的故障信息
 * @param {*} params
 * @returns
 */

export const DeviceFaultLog = params => {
  return request('get', `${baseUrl}/api/auth/sys/log/fault`, params);
};
